import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { hasPath, path } from 'ramda';
import { Controller, useFormContext } from 'react-hook-form';

import { STATE_ABBREVIATIONS } from '../constants';
import { styles } from '../styles/signUpRoute.styles';

const AddressInputs = () => {
	const {
		control,
		formState: { errors }
	} = useFormContext();

	return (
		<>
			<Grid item xs={12}>
				<Controller
					name="street"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							{...field}
							variant="outlined"
							label="Street"
							type="text"
							helperText={path(['street', 'message'], errors)}
							error={hasPath(['street', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={6}>
				<Controller
					name="city"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							{...field}
							variant="outlined"
							label="City"
							type="text"
							helperText={path(['city', 'message'], errors)}
							error={hasPath(['city', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={3}>
				<Controller
					control={control}
					name="state"
					defaultValue="AL"
					render={({ field }) => (
						<FormControl required sx={styles.formControl}>
							<InputLabel id="demo-simple-select-label">State</InputLabel>
							<Select
								native
								fullWidth
								{...field}
								variant="outlined"
								labelId="demo-simple-select-label"
								id="demo-simple-select"
							>
								{STATE_ABBREVIATIONS.map(state => (
									<option key={state} value={state}>
										{state}
									</option>
								))}
							</Select>
						</FormControl>
					)}
				/>
			</Grid>
			<Grid item xs={3}>
				<Controller
					name="zipcode"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							{...field}
							variant="outlined"
							label="Zip"
							type="number"
							helperText={path(['zipcode', 'message'], errors)}
							error={hasPath(['zipcode', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
		</>
	);
};

export default AddressInputs;
